module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-right-8932d3900cf7b41c2a0660ee16fd12e5.svg";